var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcUrl = function SvgIcUrl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.583 17.833H13.75a.916.916 0 1 1 0-1.833h1.833a4.589 4.589 0 0 0 4.584-4.583 4.589 4.589 0 0 0-4.584-4.584H13.75a.916.916 0 1 1 0-1.833h1.833A6.424 6.424 0 0 1 22 11.417a6.424 6.424 0 0 1-6.417 6.416Zm-7.333 0H6.417A6.424 6.424 0 0 1 0 11.417 6.424 6.424 0 0 1 6.417 5H8.25a.916.916 0 1 1 0 1.833H6.417a4.589 4.589 0 0 0-4.584 4.584A4.589 4.589 0 0 0 6.417 16H8.25a.916.916 0 1 1 0 1.833Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.749 12.333h-5.5a.916.916 0 1 1 0-1.833h5.5a.916.916 0 1 1 0 1.833Z"
  })));
};
export default SvgIcUrl;